import type PacksFilters from "enums/licensing/PacksFilters";
import ReducerEntityPrefixTypes from "enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "enums/reducer/reducerNamespaceTypes";
import { type GenericFiltersMap } from "utils/filterUtils";
import { type RootState } from "features/Application/globaltypes/redux";
import { createFiltersSlice, type FiltersState } from "features/Application/slices/createFiltersSlice";

export const initialState: FiltersState<PacksFilters> = {
  filterOptions: {} as GenericFiltersMap<PacksFilters>,
  appliedFilter: {} as GenericFiltersMap<PacksFilters>,
  isLoading: false,
};

export const availablePacksFiltersSlice = createFiltersSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Licensing,
    entity: ReducerEntityPrefixTypes.AvailablePacks,
    name: "filters",
  },
  initialState,
  reducers: {},
});

export const { setAppliedFilter, resetAppliedFilter, setIsLoading, setError, setFilterOptions, setSearch } =
  availablePacksFiltersSlice.actions;

export const appliedFiltersSelector = (state: RootState) => state.accounts.availablePacksFilters.appliedFilter;
export const filterOptionsSelector = (state: RootState) => state.accounts.availablePacksFilters.filterOptions;
export const isLoadingSelector = (state: RootState) => state.accounts.availablePacksFilters.isLoading;
export const availablePacksSearchTermSelector = (state: RootState) => state.accounts.availablePacksFilters.search;

export default availablePacksFiltersSlice.reducer;
